// extracted by mini-css-extract-plugin
export default {"container":"W2eeYJ","label":"wx2cF8","tooltipContainer":"rDwFbz","nameContainer":"XH4Biv","nameButton":"MOrAyx","name":"qcCkEB","tooltip":"JwI57j","loader":"ocAEgs"};